import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import DefaultLayout from "../layouts/index";
import Login from "../pages/auth/Login";
import NewPassword from "../pages/auth/NewPassword";
import PasswordSuccessful from "../pages/auth/PasswordSuccessful";
import ResetPassword from "../pages/auth/ResetPassword";
import Dashboard from "../pages/dashboard/Dashboard";
import Profile from "../pages/profile/Profile";
import StaffAccount from "../pages/account/Account";
import CreateEditStaffAccount from "../pages/account/CreateEditStaffAccount";
import Notification from "../pages/notification/Notification";
import ProductInterest from "../pages/productInterest/ProductInterest";
import ServiceRequest from "../pages/serviceRequest/ServiceRequest";
import ViewService from "../pages/serviceRequest/ViewService";
import ServiceReport from "../pages/serviceRequest/serviceReport/ServiceReport";
import ViewServiceReport from "../pages/serviceRequest/serviceReport/ViewServiceReport";
import Outlets from "../pages/outlet/outlet";
import AddNewOutlet from "../pages/outlet/AddEditOutlet";
import OutletInformation from "../pages/outlet/ViewOutlet";

const AppRoutes = () => {
  return (
    <>
      <ToastContainer position="bottom-right" theme="colored" style={{ zIndex: 99999 }} />
      <Routes>
        {/* Auth */}
        <Route exact path="/login" status={401} element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/new-password/:email/:token" element={<NewPassword />} />
        <Route path="/password-successful" element={<PasswordSuccessful />} />
        {/* DefaultLayout */}
        <Route path="/" element={<DefaultLayout />}>
          {/* Dashboard */}
          <Route index exact element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          {/* account */}
          <Route path="/staff-accounts" element={<StaffAccount />} />
          <Route
            path="/create-edit-staff-account"
            element={<CreateEditStaffAccount />}
          />
          {/* notification */}
          <Route path="/notification" element={<Notification />} />
          {/* ProductInterest */}
          <Route path="/product-interest" element={<ProductInterest />} />
          {/* Service request */}
          <Route path="/services" element={<ServiceRequest />} />
          <Route path="/view-service" element={<ViewService />} />
          {/* Service Report */}
          <Route path="/service-report" element={<ServiceReport />} />
          <Route path="/view-report" element={<ViewServiceReport />} />
          {/* Outlets */}
          <Route path="/companies" element={<Outlets />} />
          <Route path="/create-edit-outlet" element={<AddNewOutlet />} />
          <Route path="/view-outlet" element={<OutletInformation />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoutes;
